// Central API service
// Set VUE_APP_API_URL in your .env file, e.g.:
//   VUE_APP_API_URL=http://localhost:3000
// In production, set it to your deployed backend URL.

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

async function fetchCategory(category) {
  const res = await fetch(`${BASE_URL}/api/${category}`)
  if (!res.ok) throw new Error(`Failed to load ${category}`)
  const items = await res.json()
  // Prepend backend URL to any relative /uploads/ paths
  return items.map(item => ({
    ...item,
    image_url: item.image_url.startsWith('/uploads/')
      ? `${BASE_URL}${item.image_url}`
      : item.image_url
  }))
}
export const api = {
  getTul:   () => fetchCategory('tul'),
  getFon:   () => fetchCategory('fon'),
  getStor:  () => fetchCategory('stor'),
  getCeyiz: () => fetchCategory('ceyiz'),
}
